module.exports = __webpack_public_path__ + "img/portfolio-12-481x325.4dcef447.jpg";